import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import MultipleImagePanel from '../../common/image/MultipleImagePanel';
import PropertyDetail from './PropertyDetail';
import PropertyItem from './PropertyItem';
import PropertyPanel from './PropertyPanel';
import styles from "../../../../components/Display/Wrapper.module.scss";

function PropertyPage({ isActive }) {
  const { setActiveView, navigationContext } = useNavigationContext();
  const { accountContext } = useAccountContext();
  const [propertyList, setPropertyList] = useState([]);
  const [propertyDetail, setPropertyDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagesManagerIsOpen, setImagesManagerIsOpen] = useState(false);
  const [layout, setLayout] = useState('grid');

  const fetchPropertyList = async () => {
    await privateFetch('GET', 'diardexpertise', `/cu/${accountContext.id}/property/`).then(
      (res) => {
        setPropertyList(res);
      }
    );
  };

  useEffect(() => {
    fetchPropertyList();
  }, []);

  useEffect(() => {
    if (navigationContext.activePropertyId) {
      fetchPropertyDetail();
    } else setPropertyDetail(undefined);
  }, [navigationContext]);

  const fetchPropertyDetail = async () => {
    await privateFetch(
      'GET',
      'diardexpertise',
      `/cu/${accountContext.id}/property/${navigationContext.activePropertyId}/`
    ).then((res) => {
      if (res) setPropertyDetail(res);
    });
  };

  const handleClickProperty = (property) => {
    setActiveView("defproperty", property, "activePropertyId");
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const createProperty = async (propertyForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'diardexpertise',
      `/cu/${accountContext.id}/property/`,
      'La propriété a bien été ajoutée',
      JSON.stringify(propertyForm)
    ).then(() => {
      fetchPropertyList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateProperty = async (propertyForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'diardexpertise',
      `/cu/${accountContext.id}/property/${propertyDetail.id}/`,
      'La propriété a bien été modifiée',
      JSON.stringify(propertyForm)
    ).then(() => {
      fetchPropertyList();
      setPanelIsOpen(false);
      fetchPropertyDetail(propertyDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProperty = async (property) => {
    await privateFetch(
      'DELETE',
      'diardexpertise',
      `/cu/${accountContext.id}/property/${property.id}/`,
      'La propriété a bien été supprimée'
    ).then(() => {
      fetchPropertyList();
      setPropertyDetail(undefined);
    });
  };

  const newPropertyAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une propriété',
    icon: 'pi-plus'
  };

  const goBackPropertyAction = {
    onClick: handleClickProperty,
    label: 'Retour à la liste'
  };

  const updatePropertyImages = async (images) => {
    await privateFetch(
      'PUT',
      'diardexpertise',
      `/cu/${accountContext.id}/property/${propertyDetail.id}/images/`,
      'Les images de la propriété ont bien été modifiées',
      JSON.stringify({
        images: images.map((image) => image.id)
      })
    ).then(() => {
      fetchPropertyDetail();
      setLoading(false);
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };



  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Propriétés"
        labelAction={handleClickProperty}
        actions={propertyDetail ? [goBackPropertyAction] : [changeLayoutAction, newPropertyAction]}
        detail={propertyDetail}>
        {!propertyDetail ? (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {propertyList.map((property, index) => (
                <PropertyItem
                  property={property}
                  key={index}
                  layout={layout}
                  handleClickProperty={() => handleClickProperty(property)} />
              ))}
            </div>
          </div>
        ) : (
          <PropertyDetail
            property={propertyDetail}
            handleUpdateProperty={handleOpenManager}
            handleUpdateImages={() => setImagesManagerIsOpen(true)}
            handleDelete={handleDeleteProperty}
          />
        )}

        <PropertyPanel
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          property={propertyDetail}
          onCreate={createProperty}
          onUpdate={updateProperty}
          loading={loading}
        />

        <MultipleImagePanel
          loading={loading}
          isOpen={imagesManagerIsOpen}
          onClose={() => {
            setImagesManagerIsOpen(false);
          }}
          images={propertyDetail?.images}
          onValidate={updatePropertyImages}
        />
      </PageWrapper>
    </div>
  );
}

export default PropertyPage;
